import {Header} from "../components/Header";
import {Group} from '@mantine/core';
import {JellyfishNav} from "../components/JellyfishNav";
import {JellyfishTextSection} from "../components/JellyfishTextSection";
import {TableOfContents} from "../components/TableOfContents";

const JellyfishPage = () => {
    return (
        <>
            <Header/>
            <Group style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
                   align="flex-start"
                   justify="space-between"
                   wrap="nowrap"
                   gap="xl"
            >
                <TableOfContents/>
                <JellyfishTextSection/>
                <JellyfishNav/>
            </Group>
        </>
    )
}

export default JellyfishPage;